module.exports = __webpack_public_path__ + "media/images/icons/outlined/ordered-list-c702c17b9d1a05bb547567dfd86e3fae.svg";